import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  sidenavOpened = false;
  isHandset$: Observable<boolean>;
  private readonly handsetQuery = '(max-width: 1023px)';

  constructor() {
    this.isHandset$ = this.createIsHandsetStream();
  }

  toggleSideNav() {
    this.sidenavOpened = !this.sidenavOpened;
  }

  private createIsHandsetStream(): Observable<boolean> {
    if (
      typeof window === 'undefined' ||
      !window.matchMedia
    ) {
      return new Observable<boolean>((subscriber) => {
        subscriber.next(false);
        subscriber.complete();
      });
    }

    return new Observable<boolean>((subscriber) => {
      const mediaQueryList = window.matchMedia(
        this.handsetQuery
      );
      const emit = (matches: boolean) => {
        subscriber.next(matches);
      };
      const handler = (event: MediaQueryListEvent) => {
        emit(event.matches);
      };

      emit(mediaQueryList.matches);

      if (mediaQueryList.addEventListener) {
        mediaQueryList.addEventListener('change', handler);
      } else {
        mediaQueryList.addListener(handler);
      }

      return () => {
        if (mediaQueryList.removeEventListener) {
          mediaQueryList.removeEventListener(
            'change',
            handler
          );
        } else {
          mediaQueryList.removeListener(handler);
        }
      };
    }).pipe(shareReplay({ bufferSize: 1, refCount: true }));
  }
}
